import { render, staticRenderFns } from "./AppAdvertImgs.vue?vue&type=template&id=5d10bf0b&scoped=true"
import script from "./AppAdvertImgs.vue?vue&type=script&lang=js"
export * from "./AppAdvertImgs.vue?vue&type=script&lang=js"
import style0 from "./AppAdvertImgs.vue?vue&type=style&index=0&id=5d10bf0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10bf0b",
  null
  
)

export default component.exports